// dateUtils.js
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

// Function to format date with timezone
export const formatDateWithTimezone = (dateString, tz = 'Africa/Nairobi') => {
    const parts = dateString.split('-');
    const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;

    return dayjs(formattedDate)
        .tz(tz)
        .format('MMMM D, YYYY HH:mm (z)');
};

// Function to format date without timezone
export const formatDateSimple = (dateString) => {
    const parts = dateString.split('-');
    return dayjs(`${parts[2]}-${parts[1]}-${parts[0]}`).format('MMM D, YYYY');
};
